import { useCallback, useEffect, useMemo } from "react";
//import { trackShare } from '../adobeAnalytics';
import Link from "../components/Link";
import { useLocale } from '../Locale';
import I18n from '../components/I18n';
import { FacebookProvider, Share } from 'react-facebook';
import canvasToImage from 'canvas-to-image';
import {trackShare, AriyaGameAnalytics} from '../adobeAnalytics';

// eslint-disable-next-line no-undef
const url = PUBLIC_URL + "/AriyaGame/index.html";

const AriyaGame = () =>{
    const locale = useLocale();
    const shareUrl = window.location.href;
    // eslint-disable-next-line no-undef
    const downloadImgUrl = PUBLIC_URL + `/images/DrivingGame-ShareImage-${locale}-1280x720.jpg`;

    const backUrl = useMemo(() => {
        const hash = `/${locale}/experience`;
        return process.env.NODE_ENV === 'production' ? new URL(`./index.html#${hash}`, window.location.href).toString() : hash;
      }, [locale]);

	if (process.env.NODE_ENV !== 'production') {
		window.getMeta = () => ({
            title: I18n.getTranslation(locale, `ariya.share.title`),
            description: I18n.getTranslation(locale, `ariya.share.desc`),
            'og:image': downloadImgUrl,
            'og:url': shareUrl,
            'twitter:card': 'summary_large_image',
            'twitter:title': I18n.getTranslation(locale, `ariya.share.title`),
            'twitter:description': I18n.getTranslation(locale, `ariya.share.desc`),
            'twitter:image': downloadImgUrl,
		});
    }

	useEffect(() => {
		AriyaGameAnalytics.TrackLoadingScreen();
	}, []);

    const closeAriyaGame = () =>{
		AriyaGameAnalytics.TrackHome();
        document.querySelector(".back-home").click();
    }
    const shareAriyaFacebook = ()=>{
        document.querySelector(".btn-share.facebook").click();
    }
    const onFacebookShare = (originalFn) => {
        return (e, analytics) => {
          trackShare('ariya-game', shareUrl, 'share', 'intention', 'facebook');
          originalFn(e);
        };
      };
    const shareAriyaTwitter = useCallback(
        (e) => {
            trackShare('ariya-game', shareUrl, 'share', 'intention', 'twitter');
            const text = encodeURIComponent(I18n.getTranslation(locale, 'ariya.share.twitter'));
            let targetUrl = 'https://twitter.com/intent/tweet?text=' + text + '&url=' + encodeURIComponent(shareUrl);
            window.open(targetUrl, '_blank');
        },
        [locale, shareUrl],
    );

    Object.assign(window, {
        closeGame(){
            closeAriyaGame();
        },
        shareFacebook(){
            shareAriyaFacebook();
        },
        shareTwitter(){
            shareAriyaTwitter();
        },
        async shareDownload(){
			trackShare('ariya-game', shareUrl, 'share', 'intention', 'download');
            //init canvas
            const canvas = document.querySelector('#ariya-download-canvas');
            const context = canvas.getContext('2d');
            //set canvas size
            canvas.width = 1280;
            canvas.height = 720;
            //clear
            context.clearRect(0, 0, canvas.width, canvas.height);
            //add bg color
            context.fillStyle = '#000';
            context.fillRect(0, 0, 1280, 720);
            //add bg
            const image = new Image();
            const imagesLoad = Promise.all([
                new Promise((f) => (image.onload = f)),
            ]);
          
            image.src = downloadImgUrl;
        
            await imagesLoad;
        
            context.drawImage(image, 0, 0, 1280, 720);
            //init download
            
            canvasToImage(canvas, {
                name: 'nissan-ariya',
                type: 'jpg',
                quality: 1,
            });
        }
    });

    return(
        <div className="ariya-game">
            <iframe title="nissan-ariya" src={url}></iframe>
            <canvas id="ariya-download-canvas"></canvas>
            <FacebookProvider appId="607295890692254">
                <Share href={shareUrl}>
                  {({ handleClick }) => (
                    <button className="btn-share facebook" onClick={onFacebookShare(handleClick)} text="facebook share" />
                  )}
                </Share>
            </FacebookProvider>
            <Link text={'home'} href={backUrl} className="back-home" transition />
        </div>
    )
}

export default AriyaGame;